export default __webpack_public_path__ + "static/Vision-new-d0061114492c552b643dabafaf1cc371.jpg";